import type { AppRole } from '../../types/domain'

export function hasAdminRole(roles: AppRole[]) {
  return (
    roles.includes('admin') || roles.includes('operations_admin') || roles.includes('superadmin')
  )
}

export function isOperationsAdmin(roles: AppRole[]) {
  return roles.includes('operations_admin')
}

export function isSuperadmin(roles: AppRole[]) {
  return roles.includes('superadmin')
}
